import BarIndicatorWithLabels, {
	TooltipContent,
} from './BarIndicatorWithLabels';

export { TooltipContent };

export default BarIndicatorWithLabels;
